export const storeCompanyId = (ID: number) => {
  localStorage.setItem("@P3M3:lastOpenItem", ID.toString());
};
export const getCompanyId = () => {
  return localStorage.getItem("@P3M3:lastOpenItem")
    ? localStorage.getItem("@P3M3:lastOpenItem")
    : null;
};
